import { useQuery } from '@tanstack/react-query';
import { type Branding, DEFAULT_BRANDING } from '../branding';
export function useBranding() {
  const { data } = useQuery({
    queryKey: ['branding'],
    queryFn: async (): Promise<Branding> => {
      const response = await fetch('/api/branding');
      if (!response.ok) throw new Error('Branding unavailable');
      const value = await response.json();
      return typeof value?.companyName === 'string'
        ? {
            companyName: value.companyName,
            logoDataUrl:
              typeof value.logoDataUrl === 'string' &&
              value.logoDataUrl.startsWith('data:image/png;base64,')
                ? value.logoDataUrl
                : null,
          }
        : DEFAULT_BRANDING;
    },
    staleTime: 30_000,
    refetchInterval: 60_000,
    retry: false,
  });
  return data ?? DEFAULT_BRANDING;
}
